import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const COLORS = ['#10b981', '#3b82f6', '#8b5cf6', '#f59e0b', '#ef4444', '#ec4899', '#14b8a6', '#6366f1', '#84cc16', '#06b6d4', '#f97316', '#a855f7', '#64748b'];

export default function CategoryBreakdown({ receipts = [] }) {
  const categoryTotals = receipts.reduce((acc, r) => { const cat = r.category || 'other'; acc[cat] = (acc[cat] || 0) + (r.amount || 0); return acc; }, {});
  const data = Object.entries(categoryTotals).map(([name, value]) => ({ name: name.replace(/_/g, ' '), value })).sort((a, b) => b.value - a.value).slice(0, 8);
  const total = data.reduce((sum, item) => sum + item.value, 0);
  const fmt = (v) => new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', minimumFractionDigits: 0 }).format(v);
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload?.length) {
      const item = payload[0];
      return (
        <div className="bg-white p-3 rounded-xl shadow-lg border border-slate-100">
          <p className="font-medium text-slate-900 capitalize">{item.name}</p>
          <p className="text-emerald-600">{fmt(item.value)}</p>
          <p className="text-slate-500 text-sm">{((item.value / total) * 100).toFixed(1)}%</p>
        </div>
      );
    }
    return null;
  };
  if (data.length === 0) return <div className="h-[300px] flex items-center justify-center text-slate-500">No spending data</div>;
  return (
    <div className="h-[300px] w-full" data-testid="category-chart">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie data={data} cx="50%" cy="50%" innerRadius={60} outerRadius={100} paddingAngle={2} dataKey="value">
            {data.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend formatter={(v) => <span className="capitalize text-sm text-slate-600">{v}</span>} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
